module.exports = __webpack_public_path__ + "static/media/icon-sos.e6ef5806.svg";